import React, { useCallback, useEffect } from 'react';

import DataTable from 'datatables.net-react';
import DT from 'datatables.net-bs5';
import 'datatables.net-responsive-dt';
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import languageES from 'datatables.net-plugins/i18n/es-ES.mjs';
import languageEU from 'datatables.net-plugins/i18n/eu.mjs';
import languageCA from 'datatables.net-plugins/i18n/ca.mjs';
import languageGL from 'datatables.net-plugins/i18n/gl.mjs';
 
DataTable.use(DT);


export function TableWidget({configuration, tableRef}) {
  switch (configuration.active_language) {
    case "es":
      configuration.language = languageES;
      break;
    case "eu":
      configuration.language = languageEU;
      break;
    case "ca":
      configuration.language = languageCA;
      break;
    case "gl":
      configuration.language = languageGL;
      break;
  }

  return (
    <DataTable options={configuration} ref={tableRef} className="table"></DataTable>
  )
}
